@use "../../../assets/styles/abstracts/variables" as v;

.loaderWrap {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.loader {
  font-size: 4px;
  width: 1.0em;
  height: 1.0em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: spinner 1.1s infinite ease;
  transform: translateZ(0);

  @keyframes spinner {
    0%,
    100% {
      box-shadow: 0 -2.6em 0 0 v.$storm-color, 1.8em -1.8em 0 0 rgb(158 169 185 / 20%), 2.5em 0 0 0 rgb(158 169 185 / 20%), 1.75em 1.75em 0 0 rgb(158 169 185 / 20%), 0 2.5em 0 0 rgb(158 169 185 / 20%), -1.8em 1.8em 0 0 rgb(158 169 185 / 20%), -2.6em 0 0 0 rgb(158 169 185 / 50%), -1.8em -1.8em 0 0 rgb(158 169 185 / 70%);
    }

    12.5% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 70%), 1.8em -1.8em 0 0 v.$storm-color, 2.5em 0 0 0 rgb(158 169 185 / 20%), 1.75em 1.75em 0 0 rgb(158 169 185 / 20%), 0 2.5em 0 0 rgb(158 169 185 / 20%), -1.8em 1.8em 0 0 rgb(158 169 185 / 20%), -2.6em 0 0 0 rgb(158 169 185 / 20%), -1.8em -1.8em 0 0 rgb(158 169 185 / 50%);
    }

    25% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 50%), 1.8em -1.8em 0 0 rgb(158 169 185 / 70%), 2.5em 0 0 0 v.$storm-color, 1.75em 1.75em 0 0 rgb(158 169 185 / 20%), 0 2.5em 0 0 rgb(158 169 185 / 20%), -1.8em 1.8em 0 0 rgb(158 169 185 / 20%), -2.6em 0 0 0 rgb(158 169 185 / 20%), -1.8em -1.8em 0 0 rgb(158 169 185 / 20%);
    }

    37.5% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 20%), 1.8em -1.8em 0 0 rgb(158 169 185 / 50%), 2.5em 0 0 0 rgb(158 169 185 / 70%), 1.75em 1.75em 0 0 v.$storm-color, 0 2.5em 0 0 rgb(158 169 185 / 20%), -1.8em 1.8em 0 0 rgb(158 169 185 / 20%), -2.6em 0 0 0 rgb(158 169 185 / 20%), -1.8em -1.8em 0 0 rgb(158 169 185 / 20%);
    }

    50% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 20%), 1.8em -1.8em 0 0 rgb(158 169 185 / 20%), 2.5em 0 0 0 rgb(158 169 185 / 50%), 1.75em 1.75em 0 0 rgb(158 169 185 / 70%), 0 2.5em 0 0 v.$storm-color, -1.8em 1.8em 0 0 rgb(158 169 185 / 20%), -2.6em 0 0 0 rgb(158 169 185 / 20%), -1.8em -1.8em 0 0 rgb(158 169 185 / 20%);
    }

    62.5% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 20%), 1.8em -1.8em 0 0 rgb(158 169 185 / 20%), 2.5em 0 0 0 rgb(158 169 185 / 20%), 1.75em 1.75em 0 0 rgb(158 169 185 / 50%), 0 2.5em 0 0 rgb(158 169 185 / 70%), -1.8em 1.8em 0 0 v.$storm-color, -2.6em 0 0 0 rgb(158 169 185 / 20%), -1.8em -1.8em 0 0 rgb(158 169 185 / 20%);
    }

    75% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 20%), 1.8em -1.8em 0 0 rgb(158 169 185 / 20%), 2.5em 0 0 0 rgb(158 169 185 / 20%), 1.75em 1.75em 0 0 rgb(158 169 185 / 20%), 0 2.5em 0 0 rgb(158 169 185 / 50%), -1.8em 1.8em 0 0 rgb(158 169 185 / 70%), -2.6em 0 0 0 v.$storm-color, -1.8em -1.8em 0 0 rgb(158 169 185 / 20%);
    }

    87.5% {
      box-shadow: 0 -2.6em 0 0 rgb(158 169 185 / 20%), 1.8em -1.8em 0 0 rgb(158 169 185 / 20%), 2.5em 0 0 0 rgb(158 169 185 / 20%), 1.75em 1.75em 0 0 rgb(158 169 185 / 20%), 0 2.5em 0 0 rgb(158 169 185 / 20%), -1.8em 1.8em 0 0 rgb(158 169 185 / 50%), -2.6em 0 0 0 rgb(158 169 185 / 70%), -1.8em -1.8em 0 0 v.$storm-color;
    }
  }
}
